import React from "react";

import dayjs from "dayjs";
import { Loading } from "icons";

import { Typography, Tag, Tooltip } from "clearsense-ui/components";
import { LinkText } from "components/Common/TableStyle";
import { getTimeAndDate } from "utils/date";

import { getStatusColor } from "../../utils";

const COLUMN_DATA = [
  {
    dataIndex: "name",
    key: "name",
    title: "Name",
    fixed: "left",
    width: 250,
    render: (_, record) => {
      const isFinished = record.status === "finished";

      return isFinished ? (
        <LinkText
          text={record.name}
          link={`${record.id}/summary`}
          className="capitalize"
        />
      ) : (
        <Typography type="semibold" className="capitalize">
          {record.name}
        </Typography>
      );
    },
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    dataIndex: "target",
    key: "target",
    title: "Target",
    width: 200,
    sorter: (a, b) => a.target.localeCompare(b.target),
  },
  {
    dataIndex: "analysisType",
    key: "analysisType",
    title: "Analysis Type",
    width: 250,
    sorter: (a, b) => a.analysisType.localeCompare(b.analysisType),
  },
  {
    dataIndex: "runDate",
    key: "runDate",
    title: "Run Date",
    width: 200,
    render: (_, { runDate }) => {
      if (!runDate) return "Not available";
      const convertedDate = dayjs.unix(runDate);
      const { date, time } = getTimeAndDate(convertedDate);

      return (
        <Tooltip content={convertedDate.fromNow()} position="bottom">
          <Typography>{`${date} ${time}`}</Typography>
        </Tooltip>
      );
    },
    sorter: (a, b) => a.runDate - b.runDate,
  },
  {
    dataIndex: "status",
    key: "status",
    title: "Status",
    width: 150,
    align: "center",
    render: (_, record) => {
      const isRunning = record.status === "running";

      const commonProps = {
        color: getStatusColor(record.status),
        label: record?.status,
        "data-cy": "analysis-status-tag",
        className: "capitalize",
      };

      return isRunning ? (
        <Tag {...commonProps} icon={Loading} />
      ) : (
        <Tag {...commonProps} />
      );
    },
    sorter: (a, b) => a.status.localeCompare(b.status),
  },
];

export { COLUMN_DATA };
